import React from 'react';
import { DeleteButton } from '../../components/DeleteButton';
import { useFormInstance } from './FormContext';
import { useFormInstanceDispatch } from './FormInstance.service';
export function SimpleFormClearButton() {
    let formInstance = useFormInstance();
    let dispatch = useFormInstanceDispatch(formInstance);
    const handleClearSubmission = () => {
        dispatch("clearForm");
    };
    return React.createElement(DeleteButton, { iconOnly: true, buttonText: "Clear", title: "Clear submission", message: "Are you sure you want to clear this submission? This will clear the form data and any conversation history.", onConfirm: handleClearSubmission });
}
